export default {
  app: {
    title: '智能硬件经销商管理系统',
    emergencyContactSettingsTitle: '紧急联系人设置',
    emergencyContactTableSerial: '序列',
    emergencyContactTableName: '姓名',
    emergencyContactTablePhone: '手机号',
    emergencyContactTableDingTalk: '钉钉号',
    /** 紧急联系人表格「序号」列：紧急联系人1、紧急联系人2 */
    emergencyContactWithIndex: '紧急联系人{n}',
    followUpStudentTitle: '跟进学员',
    followUpStudentTabAddFollow: '添加跟进',
    followUpStudentTabCompleteProfile: '完善资料',
    followUpStudentStudentName: '学员姓名',
    followUpStudentCustomerIntent: '客户意向度',
    followUpStudentFollowStatus: '跟进状态',
    followUpStudentStudentTags: '学员标签',
    followUpStudentCallCommStatus: '话务沟通状态',
    followUpStudentFollowContent: '跟进内容',
    followUpStudentFollowContentTipLine1: '如：今天是第几次跟进；讲解了松鼠Ai的优势等；学员的意向科目是什么；',
    followUpStudentFollowContentTipLine2: '家长态度如何;是否预约下次跟进等...',
    followUpStudentUploadImageHint: '支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB',
    followUpStudentCredentialSample: '凭证实例',
    followUpStudentNextCommTime: '下次沟通时间',
    followUpStudentSelectDate: '选择日期',
    followUpStudentSelectTime: '选择时间',
    followUpStudentPlaceholderSelectIntent: '请选择客户意向度',
    followUpStudentPlaceholderSelectFollowStatus: '请选择跟进状态',
    followUpStudentPlaceholderFollowContent: '请输入跟进内容',
    followUpStudentPhone: '手机号',
    followUpStudentPlaceholderPhone: '请输入手机号',
    followUpStudentSex: '性别',
    followUpStudentMale: '男',
    followUpStudentFemale: '女',
    followUpStudentBirthday: '出生日期',
    followUpStudentPlaceholderBirthday: '选择出生日期',
    followUpStudentHomeAddress: '家庭住址',
    followUpStudentPlaceholderHomeAddress: '请输入家庭地址',
    followUpStudentStudentType: '学员类型',
    followUpStudentPlaceholderSelectStudentType: '请选择学员类型',
    followUpStudentStageGrade: '阶段年级',
    followUpStudentPlaceholderSelectStage: '请选择阶段',
    followUpStudentPlaceholderSelectGrade: '请选择年级',
    followUpStudentSource: '来源',
    followUpStudentStudentSchool: '学员学校',
    followUpStudentPlaceholderSelectSchool: '请选择学员学校',
    followUpStudentCourseAdvisor: '课程顾问',
    followUpStudentPlaceholderSelectAdvisor: '请选择课程顾问',
    followUpStudentRegionOne: '区域一',
    followUpStudentRegionTwo: '区域二',
    followUpStudentContact1: '联系人1',
    followUpStudentPlaceholderContact1: '请输入联系人1',
    followUpStudentContact2: '联系人2',
    followUpStudentPlaceholderContact2: '请输入联系人2',
    followUpStudentContact3: '联系人3',
    followUpStudentPlaceholderContact3: '请输入联系人3',
    followUpStudentRemark: '备注',
    followUpStudentPlaceholderRemark500: '500字以内',
    selectProductTitle: '选择商品',
    confirmDeleteComponent: '您确定要删除该组件吗?',
    logisticsDetailsTitle: '物流详情',
    cannotSubscribeTipTitle: '不可订阅提示',
    shipmentTitle: '发货',
    assignCoursesTitle: '分配课程',
    batchCancelAssignedCoursesTitle: '批量取消分配课程',
    editSchoolTitle: '编辑学校',
    addSchoolTitle: '新增学校',
    editInfoTitle: '编辑资料',
    addInformationTitle: '新增资料',
    addRelatedOrderTitle: '新增关联订单',
    verificationPromptTitle: '验证提示',
    addInvoiceTitle: '新增发票',
    addContractTitle: '新增合同',
    contractInfo: '合同信息',
    multipleSchoolQueryTitle: '多校查询',
    changeDetailsTitle: '变更详情',
    subjectChangeWarningTitle: '主体变更预警',
    editAccountTitle: '编辑账号',
    addAccountTitle: '新增账号',
    agentInitialAccountAmountTitle: '代理商初始账户金额',
    cashRechargeTitle: '现金账户充值',
    switch: '切换',
    enable: '启用',
    save: '保存',
    delete: '删除',
    warning: '警告',
    edit: '编辑',
    add: '新增',
    search: '搜索',
    reset: '重置',
    refreshStatus: '刷新状态',
    export: '导出',
    exportDetail: '导出明细',
    import: '导入',
    upload: '上传',
    download: '下载',
    done: '完成',
    prevStep: '上一步',
    downloadImportTemplate: '下载导入模版',
    operation: '操作',
    operationSuccess: '操作成功',
    detail: '详情',
    details: '详情',
    userDetail: '用户详情',
    submit: '提交',
    back: '返回',
    close: '关闭',
    labelColon: '：',
    loading: '加载中...',
    pleaseEnter: '请输入',
    yuan: '元',
    complete: '完成',
    success: '操作成功',
    saveSuccess: '保存成功',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    uploadFileSize5MB: '上传文件大小不能超过 5MB!',
    failed: '操作失败',
    modifyFail: '修改失败',
    loadFail: '加载失败',
    claimFail: '领取失败',
    inviteFail: '邀约失败',
    changeFail: '更改失败',
    experienceFail: '体验失败',
    linkSuccess: '关联成功',
    linkFail: '关联失败',
    confirmSuccess: '确认成功',
    editFail: '编辑失败',
    orderQueryFail: '订单查询失败',
    createSuccess: '创建成功',
    createFail: '创建失败',
    addMaterialSuccess: '新增资料成功',
    modifyMaterialFail: '修改资料失败',
    addMaterialFail: '新增资料失败',
    deleteMaterialFail: '删除资料失败',
    helpCenter: '帮助中心',
    closeSystem: '关闭系统',
    accountSecurity: '账号安全中心',
    exportDownload: '导出下载',
    codeSendFailed: '验证码发送失败',
    days: '天',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    filterPlaceholder: '请输入搜索内容',
    available: '待选',
    selected: '已选',
    thisWeek: '本周',
    thisMonth: '本月',
    lastWeek: '上周',
    lastMonth: '上月',
    retrievePassword: '找回密码',
    retrievePasswordTip: '使用账号绑定的手机号找回密码',
    codePlaceholder: '验证码',
    send: '发送',
    countDownResend: '{n}s后重新获取',
    loginDeprecNotice: '此登录入口将于2024年10月31日正式关停，若您的账号仍未升级，请在登录后根据系统指引绑定手机号完成升级，如有疑问您可咨询松鼠智能客服。',
    newPassword: '新密码',
    pleaseEnterNewPassword: '请输入新密码',
    serialNo: '序号',
    tip: '提示',
    pleaseSelect: '请选择',
    selectAgentPlaceholder: '请选择代理商ID/代理商名称',
    searchAgentPlaceholder: '输入代理商ID/代理商名查找',
    select: '选择',
    label: '付款方式：',
    amount: '充值金额：',
    total: '总计',
    all: '全部',
    yes: '是',
    no: '否',
    public: '公共',
    private: '私有',
    attention: '注意',
    goToExportDownload: '请前往',
    importExport: '导入导出',
    goToExportDownloadSuffix: '进行下载',
    notNow: '暂不前往',
    goToDownload: '前往导出下载',
    changeVerifyPhoneTitle: '更换验证手机号-身份验证',
    changePhoneBindTitle: '更换手机号-绑定新手机号',
    copySuccess: '复制成功',
    more: '更多',
    view: '查看',
    copy: '复制',
    disabled: '禁用',
    primaryTag: '主',
    planningDept: '统筹部',
    classHours: '课时',
    classHoursWithNum: '{n}课时',
    unbound: '未绑定',
    bindPhoneTip: '绑定手机号后，可使用该手机号登录系统及找回密码',
    pinTop: '置顶',
    viewDetail: '查看详情',
    noPermissionContactAdmin: '暂无权限，请联系管理员！',
    noPermissionContactAgentAdmin: '您暂无权限，请联系代理商管理员',
    noPermissionRestrictedPrefix: '您的系统使用已被限制。限制原因：',
    noPermissionContactCustomerService: '请联系客服',
    queryBalanceFailed: '查询余额失败',
    accountCreateTip: '账号创建后，账号的状态是"待确认"，"待确认"的账号无法登录。创建的同时员工会收到总部钉钉加入的邀请，下载并打开钉钉，接受邀请加入总部后，账号就会从"待确认"变为"正常"状态，即可登录系统。',
    continue: '继续',
    accountUpgrade: '账号升级',
    accountUpgraded: '账号已经升级',
    accountUpgradeIntro: '仅需一分钟，将您的代理商账户升级为',
    squirrelAiAccount: '松鼠Ai账号',
    upgradeBenefits: '升级后获得以下权益：',
    unifiedAccount: '统一账号',
    unifiedAccountDesc: '通过一个手机号码，管理全部的代理商账号、分析员账号',
    security: '安全保密',
    securityDesc: '绑定手机和钉钉提高账号安全性',
    joinTraining: '参与培训',
    joinTrainingDesc: '加入松鼠云上钉钉组织，获得优质培训资料，了解最新功能',
    upgradeNow: '立即升级',
    bindPhone: '绑定手机号',
    bindPhoneDesc: '我们将根据手机号，创建或绑定松鼠Ai账号',
    phoneForRecovery: '请输入账号手机号，可用于找回密码',
    scanToActivate: '扫描完成账号激活',
    goToDingTalk: '前往钉钉完成升级',
    mergeAccount: '合并账号',
    mergeAccountDesc: '如果你有其他代理商账号需要合并到松鼠Ai账号，请依次添加',
    accountList: '账号列表',
    addAccount: '+添加账号',
    refresh: '刷新',
    contactService: '如遇问题请联系松鼠Ai智能客服',
    setFilterFirst: '请先设置筛选条件',
    bindMobile: '绑定手机',
    modifyPassword: '修改密码',
    salesCenter: '销售中心',
    serviceCenter: '服务中心',
    financeCenter: '财务中心',
    businessManagement: '业务管理',
    innovationBusiness: '创新业务',
    deliveryManagement: '发货管理',
    agentServiceProvider: '代理服务商',
    headquartersTools: '总部工具',
    configBackend: '后台配置',
    statisticalAnalysis: '统计分析',
    warehouseManagement: '仓库管理',
    agentManagement: '代理商管理',
    resourceLibrary: '资源库',
    referralHelpCenter: '转介绍帮助中心',
    referralPerformanceQuery: '关于转介绍业绩查询及使用规则，请参阅帮助中心；',
    referralCustomerInRegionQuery: '关于区域内转介绍客户的查询，请参阅帮助中心；',
    referralCustomerFirstContract: '关于转介绍客户首笔合同款奖励的计算规则和查询，请参阅帮助中心；',
    referralCustomerInRegion: '转介绍客户所在区域',
    channelRebateService: '关于渠道代的返佣和服务费奖励的计算规则和查询，请参阅帮助中心；',
    storageFeeExemptionNotice: '仓储费豁免公告',
    callLineBusy: '呼叫线路繁忙',
    outboundLineBusy: '外呼线路繁忙',
    notMigrated: '未迁移',
    hardPhone: '硬话机',
    timeDifferenceIs: '时间差为',
    downloadCertTemplate: '下载证书模版',
    dealerMiniProgram: '经销商小程序',
    headquartersNotice: '总部通知',
    agent: '代理商',
    dealer: '经销商',
    analyst: '分析员',
    analystAccount: '分析员账号',
    mainAccount: '主账号',
    subAccount: '子账号',
    mobile: '手机号',
    myWorkOrder: '我的工单',
    myCustomerService: '我的客服',
    noCustomerFound: '暂无客户',
    noDeviceFound: '暂无设备',
    openEntryAccount: '入门账号开通',
    learningMachine: '学习机',
    creditOrders: '赊货订单',
    rechargeFlow: '充值流程',
    bigStudyRoom: '大自习室',
    texttnry: '运费方案',
    targetReminder: '目标设定提醒',
    remindLater: '稍后再说',
    goToSet: '前往设定',
    newNotice: '您有一条新的公告消息',
    viewLater: '一会查看',
    viewNow: '立即查看',
    important: '重要',
    emergency: '紧急',
    callinTip: '线索正在呼入，请及时处理！',
    leadName: '线索名字',
    leadPhone: '线索手机号',
    followStatus: '跟进状态',
    calloutNotOpen: '外呼功能未开通',
    calloutNotOpenTip: '亲爱的经销商您好，您当前使用的外呼服务处于未开通状态，您可点击"前往开通"按钮进行开通或续期操作',
    thinkAgain: '再想想',
    goToOpen: '前往开通',
    goToRecharge: '前往充值',
    calloutOverdue: '外呼功能已欠费',
    calloutOverdueTip: '亲爱的经销商您好，您当前使用的外呼服务已超出使用话费的额度，您可点击"前往充值"按钮进行话费充值操作',
    calloutBusy: '外呼功能线路繁忙',
    iKnow: '我知道了',
    gotIt: '我知道了',
    calloutBusyTip: '当前为外呼线路繁忙，预计XX分钟后将有空余线路',
    callTips: '温馨提示',
    callTipsContent: '为保证通话质量，建议您使用带麦克风的耳机插入电脑后进行外呼',
    noMoreRemind: '我知道了，无需再提醒',
    continueCallout: '继续外呼',
    ddModalJoinHqTitle: '加入松鼠云上总部',
    ddModalJoinHqSubtitle: '获取代理商运营秘笈，光速学会运营知识',
    ddModalBulletIndustry: '了解行业背景',
    ddModalBulletSystem: '学会代理商系统操作方法',
    ddModalBulletSales: '提升自己销售、服务能力',
    ddModalScanToJoin: '钉钉扫码加入',
    ddModalTrainUnlockTitle: '完成钉钉培训后解锁',
    ddModalMobileLearn: '手机钉钉扫码进行学习',
    ddModalDesktopLearn: '电脑钉钉直接学习',
    ddModalSignupFailed: '报名失败，请稍后再试',
    trainingBannerCountdownPrefix: '培训倒计时 ',
    trainingBannerUrgentSuffix: ' 天，逾期未完成，目录将会被锁定',
    trainingBannerGoTrain: '前往培训',
    headerPersonalCenter: '个人中心',
    editorPlacementAreaLabel: '组件放置区域',
    notFoundTitle: '页面不存在',
    notFoundTip: '您访问的页面不存在或已被移除',
    notFoundBackHome: '返回首页',
    passwordResetSuccess: '密码修改成功, 请使用新密码登录',
    passwordResetFail: '密码修改失败',
    verifyFail: '验证失败！',
    editAccountSuccess: '编辑账号成功！',
    editAccountFail: '编辑账号失败！',
    creditOrderPayTip: '赊货订单付款要求',
    creditOrderPayDesc: '经销商销售设备激活回款后，需要支付赊货订单的尾款，',
    exemptTip: '从收到提货券之日起',
    exemptTip2: '天内，定义为提货券的豁免期；豁免期内的提货券是免收仓储管理费的。具体规则详见：',
    exemptTip3: '根据以上规则，截止昨天你有',
    exemptTip4: '元的提货券即将过豁免期，请尽快下单支付提货券，系统将对过豁免期未下单的提货券，收取相应的仓储管理费；',
    doubleOrderTip: '双重订单是省代关联本省代理商、经销商的账户现金，实现集中备货的采购订单。具体规则详见：',
    agentAccountTip: '代理商账户常见问题',
    subscriptionTip: '订阅档位定义及查询',
    referralChannel: '转介绍及渠道代',
    guinnessTitle: '吉尼斯证书申请须知：',
    guinnessP1: '电子证书申请截⽌⽇期为',
    guinnessP2: '，请在截⽌前申请；现纸质证书已停止申请；',
    guinnessP3: '学员姓名和英⽂姓名将⽤在证书中，请认真确认与填写；',
    guinnessP4: '若想',
    guinnessP5: '修改学⽣姓名',
    guinnessP6: '，请至"家长通小程序-学习报告"中修改，如有问题请咨询客服；英文姓名请在本页填写和修改；',
    guinnessP7: '吉尼斯电⼦证书免费申请；吉尼斯纸质证书单价为{symbol}300；松鼠不收取任何中间费用；',
    guinnessP8: '电⼦证书申请后可直接下载；纸质证书由于制作时间过⻓，请耐⼼等待。',
    studentNameCertNotice: '学员姓名和英文姓名将用在证书中，请认真确认与填写；',
    modifyStudentName: '修改学生姓名',
    guinnessDigitalCertFree: '吉尼斯电子证书免费申请；吉尼斯纸质证书单价为{symbol}300；松鼠不收取任何中间费用；',
    guinnessCertDownloadWait: '电子证书申请后可直接下载；纸质证书由于制作时间过长，请耐心等待。',
    startCallout: '开始外呼',
    endCallout: '结束外呼',
    calloutOnlineSuccess: '外呼服务上线成功',
    calloutOfflineSuccess: '外呼服务下线成功',
    micPermissionFail: '麦克风权限请求失败，请检查您的浏览器设置',
    getCustomerFail: '获取客户信息失败！',
    pleaseStartCallout: '请点击右上角"开始外呼"后进行外呼～',
    serviceError: '服务异常！',
    exportTaskSubmitted: '导出任务提交成功',
    pleaseProvideApiUrl: '请传入接口路径',
    exportFailed: '导出失败',
    systemError: '系统异常，请联系管理员',
    confirmRemoveFile: '确定移除 {name}？',
    uploadImage: '上传图片',
    cancelUpload: '取消上传',
    clickUpload: '点击上传',
    within100Chars: '100字以内',
    cancelUploadConfirm: '点击取消后您填写的信息将丢失，您确定取消？',
    uploadImageFail: '上传图片失败，请删除后重新上传',
    pleaseUploadImage: '请上传图片！',
    selectCommodity: '选择商品',
    pleaseSelectJumpType: '请选择跳转类型',
    pleaseSelectImageLink: '请选择图片跳转链接',
    pleaseEnterLink: '请输入链接，输入前确保可以访问',
    pleaseSelectUser: '请选择用户',
    pleaseEnterKeywordFilter: '请输入关键字过滤',
    pleaseSelectProductType: '请选择商品类型',
    pleaseSelectCounter: '请选择柜台',
    pleaseSelectProvinceCity: '请选择省市区',
    pleaseSelectProvinceCityDistrict: '请选择省份/市',
    pleaseSelectFault: '请选择故障分类',
    pleaseSelectAgentRegion: '请选择代理商所属区域',
    startDatePlaceholder: '开始日期',
    endDatePlaceholder: '结束日期',
    clearFilter: '清除筛选',
    collapse: '收起',
    expand: '展开',
    query: '查询',
    clear: '清空',
    pleaseFillRequired: '请填写必填字段！',
    invoiceQtyDecimalQ: 'Q：为什么开票数量有是小数？',
    invoiceQtyDecimalA: 'A：货款类的提现金额是下级经销商的订货款转入代理商提现账户的钱，松鼠已经向经销商的订单开过销售发票了，因此这个货款再被提现出来，要根据原始的订单对应商品型号、单价、金额红冲发票或反向开销售发票给松鼠，根据本次申请提现的金额用到不同订单的货款，会生成对应不同金额的开票信息，金额、单价固定的情况下，数量就是小数了',
    socketConnectFailRetry: '无法连接到消息系统，请检查网络状态后重试！',
    socketConnectFailClose: '无法连接到消息系统，请关闭系统重试！',
    transferSuccess: '转交成功',
    transferFail: '转交失败',
    noPermissionAskSuperior: '暂无权限，请上级为您开通对应权限',
    pleaseSelectAdPosition: '请选择广告位置',
    pleaseEnterAdName: '请输入广告名称',
    pleaseEnterSort: '请输入排序',
    pleaseSelectStatus: '请选择状态',
    pleaseSelectDisplayScope: '请选择显示范围',
    publishSuccess: '发布成功',
    pleaseEnterContactName: '请输入联系人姓名',
    pleaseEnterCorrectPhoneNum: '请输入正确的手机号码',
    phoneInvalidDigits: '请输入有效的数字',
    phoneLengthExceed: '手机号长度不能超过20位',
    passwordSafetyTip: '为保证账户安全，请及时更新密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    pleaseEnterOldPassword: '请输入原密码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseConfirmNewPassword: '请确认新密码',
    pleaseEnterNewPasswordAgain: '请再次输入新密码',
    passwordMismatch: '两次新密码输入不一致',
    pleaseReenterNewPassword: '请重新输入新密码',
    cancel: '取消',
    confirm: '确认',
    newNotice: '您有一条新的公告消息',
    viewNoticeDetail: '查看公告详情',
    tip: '提示',
    confirmDelete: '确认删除吗？',
    confirmClose: '确认关闭？',
    confirmReturnFreight: '确定要退还运费吗？',
    returnFreightSuccess: '退还成功',
    returnFreightFail: '退还失败',
    returnGoodsTip: '发货订单退货后，设备sn码将退回，发货信息将删除，请谨慎操作！',
    returnGoodsSuccess: '退货成功',
    codeSentSuccess: '验证码发送成功',
    passwordResetSuccess: '密码重置成功, 请使用新密码登录',
    passwordResetFail: '密码重置失败',
    login: '登录',
    passwordLogin: '密码登录',
    phoneLogin: '验证码登录',
    usernamePlaceholder: '请输入用户名/手机号',
    passwordPlaceholder: '请输入密码',
    phone: '手机号',
    password: '密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码',
    loginSuccess: '登录成功',
    verifySuccess: '验证成功',
    pleaseEnterPhone: '请输入手机号',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterVerifyCode: '请输入验证码',
    pleaseEnterOriginalPhone: '请输入原手机号',
    pleaseEnterNewPhone: '请输入新手机号',
    invalidPhone: '请输入有效的手机号',
    bindSuccess: '绑定成功',
    upgradeSuccess: '您的账号已经升级为松鼠Ai账号，请从统一登录平台登录',
    permissionError: '啊欧，您的访问权限异常，请联系客服进行处理',
    codeSentTip: '验证码发送成功，请在手机上查看！',
    popupWillCloseIn: '弹窗将在',
    secondsAutoClose: '秒后自动关闭',
    auto_1_33bb0b88: '大模型数据分析服务系',
    unsupervisedStudentDataTip: '不督学学员的学情数据，可前往大模型数据分析服务系统查看',
    auto_1_4419517d: '上海市普陀区金沙江路',
    auto_11_3c1407e3: '本次支付将扣除',
    auto_12_21efd9b0: '请确认是否取消订单一旦取消已支付款项会退回',
    auto_14_7788d61a: 'nbsp话费单价',
    auto_15_6c5f790c: '开通使用协议',
    auto_17_8032e637: '付款',
    auto_18_68eb91fb: '原价',
    auto_19_6aed0f56: '不限人数含',
    auto_20_a2a536d4: '到期自动续费',
    auto_26_f93ba179: '灵活使用',
    auto_35_056836b2: '灵活使用支持退费',
    auto_39_29fb07b1: '选定布局区域在下方添加图片',
    auto_52_cd58f41b: '请先输入开通月数',
    auto_53_9153b4fc: '请先阅读并勾选外呼服',
    auto_54_21ddab8a: '请先输入有效的话费金',
    auto_58_aaa2e80b: '购买成功',
    auto_60_6c08e91d: '下一步',
    auto_62_b7fb536e: '我的工单',
    auto_62_efa11156: '验证成功',
    auto_63_9c495a0c: '将会提交工单给技术专家进行处理',
    auto_63_c72e441b: '更换手机号绑定新手机',
    auto_65_5b3129b0: '验证码错误',
    auto_66_3d5ad168: '手机验证',
    auto_66_4c74e75e: '已完结工单',
    auto_67_99c2c990: '已完结工单是技术专家已经回复了问题结果您可以点击工单查看工单',
    auto_68_3c08da52: '确认',
    auto_68_419e05d6: '新进度',
    auto_69_31ad8c59: '您的工单都在处理中请耐心等待技术专家的回复哦',
    auto_69_b96f9f4f: '登录失败',
    auto_70_1ee3a0b3: '处理中工单',
    auto_70_9ca27d68: '证明文件',
    auto_71_44fb8798: '关闭',
    auto_71_6d2b1005: '处理中工单是客服已经帮您提交工单请耐心等待技术专家回复',
    auto_72_794828ac: '您的工单都已完结请去已完结工单中查看技术专家回复哦',
    auto_73_0771c815: '提交审核',
    auto_73_32adfc8d: '工单详情',
    auto_74_f6fd4c00: '工单信息',
    auto_75_38ddfcc9: '请输入学员账号',
    auto_75_95cc1a8c: '工单ID',
    auto_76_40dca735: '工单标题',
    auto_76_e734dd37: '情况说明长度为字',
    auto_77_39620e02: '工单创建人',
    auto_78_0d0b0047: '工单创建时间',
    auto_78_2d6f0fc5: '请上传证明文件',
    auto_79_94495c94: '请选择审核结果',
    auto_79_bd9cd84d: '工单状态',
    auto_80_0cf9382a: '工单处理人',
    auto_80_661f2449: '请输入审核意见',
    auto_81_36b9a3ac: '审核跨主体督学申请',
    auto_81_3ac0816a: '工单完结时间',
    auto_82_403c2cbf: '问题处理结果',
    auto_83_2933c8fe: '技术专家在加急处理您的问题中请您耐心等待',
    auto_84_44eecdea: '跨主体督学申请',
    auto_85_7d350f62: '学员账号验证失败',
    auto_86_492ffaa8: '验证学员账号失败请稍',
    auto_86_5646605a: '宽度',
    auto_87_4591b39a: '只能上传图片格式的文',
    auto_88_6d73238a: '上传文件大小不能超过',
    auto_89_7953c2d5: '文件上传成功',
    auto_90_33e94845: '文件上传失败',
    auto_91_2869b272: '审核拒绝',
    auto_94_15733a82: '申请前校验失败',
    auto_95_294563f7: '申请已审核无需重复提',
    auto_99_d0373366: '当前状态无需提交申请',
    auto_100_b3dad3de: '审核提交成功',
    auto_101_1a13328b: '',
    auto_102_d12681fa: '提交失败',
    auto_103_3a39ddcd: '提交失败请稍后重试',
    auto_104_4c4e4b6f: '辅助空白',
    auto_105_9be7183a: '请添加图片',
    auto_106_6d719469: '无边距',
    auto_106_ec081e14: '点击更换图',
    auto_107_f5a8f75f: '本期名额',
    auto_108_8e48f7fd: '实线',
    auto_108_e84a4be3: '限制',
    auto_109_cfe7889d: '虚线',
    auto_110_20b0a497: '支持jpgpnggif格式RGB模式不超过',
    auto_110_b7b7726f: '点线',
    auto_111_80630d3f: '显示',
    auto_115_b9db9487: '正常模式',
    auto_118_b48a6ff1: '联系电话',
    auto_119_0f491a54: '联系地址',
    auto_119_c860d08a: '方形',
    auto_120_483ae5a2: '点击上传二维码',
    auto_121_95bbd0e8: '扫码关注公众号',
    auto_123_1131d0ec: '鼠标拖拽调整商品顺序',
    auto_123_7bc0c4f1: '居左',
    auto_125_206113c3: '点击添加商品',
    auto_126_ef406980: '添加商品分组',
    auto_127_3a945992: '鼠标拖拽调整分组顺序',
    auto_129_abc25f15: '更换图片',
    auto_130_fdb36e36: '清空图片',
    auto_131_32b40046: '图片广告',
    auto_132_858e59ff: '拖动选中的导航可对其排序',
    auto_133_05ace53e: '默认颜色',
    auto_134_f4585f3e: '点击添加图片',
    auto_135_c0e8816b: '更换',
    auto_135_ebe23c00: '样式三',
    auto_137_36c54da9: '内部链接',
    auto_138_afe8814b: '外部链接',
    auto_139_fe1e30e4: '图片导航',
    auto_141_6c3240d9: '固定',
    auto_147_83c3e7b8: '采购金额',
    auto_148_b7220f0c: '实付金额',
    auto_149_4e1fcefb: '方案二运费预付',
    auto_151_e6478584: '无边白底',
    auto_152_7819c2cf: '卡片投影',
    auto_153_6dc7a4dc: '描边白底',
    auto_154_b90eeb18: '无边透明底',
    auto_155_d4ce2cfe: '大图模式',
    auto_156_83ec52fd: '一行两个',
    auto_157_258d6836: '一行三个',
    auto_158_15475824: '详细列表',
    auto_159_f61a0ab5: '一大两小',
    auto_160_33d8ef3f: '横向滑动',
    auto_161_e28f6ced: '新品',
    auto_163_4adbf233: '右下',
    auto_167_ef6a4dce: '分组',
    auto_174_756428f4: '一行二个',
    auto_176_448098ad: '一行四个',
    auto_177_0ec2a2f9: '二左二右',
    auto_178_8172d6c2: '一左二右',
    auto_179_07abf4f5: '一上二下',
    auto_179_71c7a446: '运费',
    auto_180_6d92ed35: '一左三右',
    auto_183_bd0c8844: '支持jpgpng格式最佳尺寸',
    auto_184_b68fb5c2: '凭证实例',
    auto_185_1f46ba2d: '支付',
    auto_187_8434ac96: '使用微信扫一扫',
    auto_190_4bfb417c: '一行一个',
    auto_191_ff1cbeb7: '轮播海报',
    auto_192_0bca3c45: '二维码地址不正确',
    auto_192_cbb3d8a7: '多图单行',
    auto_193_4fec09ce: '对公转账',
    auto_193_69fe8e0b: '立体轮播',
    auto_194_a5ebb961: '立即充值',
    auto_196_a5c0c783: '导航横向滑动',
    auto_198_001d1ca7: '充值成功',
    auto_215_67625bb7: '样式四',
    auto_216_388b91ad: '背景图片',
    auto_216_cbf8c407: '样式五',
    auto_217_257b91c3: '建议尺寸',
    auto_217_e38e454c: '上方',
    auto_218_9a3067d4: '下方',
    auto_219_73f2d631: '店铺头像',
    auto_228_0a0ca324: '支付方式',
    auto_241_f85bb3b7: '下级代理商',
    auto_244_9d956674: '请选择代理商',
    auto_246_d56d107e: '这里显示笔记标题最多',
    auto_249_2bd9ac7e: '如您需要转入此类学员进行服务需要提交审核后待省代同意后方能转',
    auto_251_45cf4f1a: '请上传督学服务购买凭证和与家长的沟通记录',
    auto_252_0fa164da: '点击上传图片',
    auto_253_2d63a546: '选中时',
    auto_253_9223791a: '活码是用户推广个人微信号或粉丝群的二维码适用于线上线下吸引用',
    auto_257_7db1b71e: '书籍',
    auto_258_6c743df7: '点击添加导航',
    auto_258_d996f1e4: '其他',
    auto_259_fb3017dd: '正在搜索中',
    auto_260_c50c825c: '测试',
    auto_262_2a868194: '小圆点',
    auto_262_a7b4945a: '暂无数据',
    auto_263_1e2ac1cf: '点击取消后您填写的信',
    auto_263_27550dc5: '最多添加',
    auto_264_fc834024: '暂未设置',
    auto_265_2be97a89: '未设置',
    auto_265_edec6409: '为避免您错过总部的紧急重要通知（如核心政策），系统建议您为您的组织设置最多2位紧急联系人专门用于接收此类通知并在团队内部传达。',
    auto_267_825914e3: '选择员工',
    auto_268_670ff28c: '无需设置紧急联系人点击右侧按钮取消提醒',
    auto_269_def5443e: '获取验证码',
    auto_270_57fefe83: '重新获取验证码',
    auto_273_0e2e46fd: '如今天是第几次跟进讲解了松鼠Ai的优势等学员的意向科目是什么',
    auto_273_aeb07a52: '获取紧急联系人列表失',
    auto_277_6784f2d4: '有多个督学师的学生移除后状态保持不变',
    auto_277_db75769c: '紧急联系人',
    auto_280_267d7726: '个正式学员',
    auto_285_c5128c5f: '提交成功',
    auto_293_be89a148: '关联代理账户余额',
    auto_295_6e62aa26: '请选择以下支付方式支',
    auto_296_8f6d4c1d: '收费项目',
    auto_297_8abf3e2d: '单价',
    auto_298_2da831cc: '数量',
    auto_299_39663d85: '鼠标拖拽调整热词顺序搜索框默认展示第一个热词其他搜索词将以标',
    auto_299_d9edcab4: '金额',
    auto_300_6fd6255e: '折扣',
    auto_301_1c75938c: '优惠后的金额',
    auto_301_c2563ff7: '点击添加热词',
    auto_302_6d7b34a0: '页面设置',
    auto_302_f5bb943f: '保费',
    auto_303_c3435521: '请勿操作过于频繁',
    auto_304_52a4dfe7: '发货成功',
    auto_305_1d5f092c: '鼠标拖拽调整卡片顺序',
    auto_305_69f78632: '发货失败',
    auto_306_24dad104: '付款失败',
    auto_307_c7ba6fe0: '点击添加卡片',
    auto_308_09f5aa98: '江西省景德镇市乐平市',
    auto_318_bdf9a706: '支付成功',
    auto_320_2f13c686: '底部导航组件为固定页面底部无需拖拽调整位置',
    auto_322_d314fa61: '下拉框单选多选等文本用符号隔开如男女',
    auto_323_85f1a958: '点击添加内容',
    auto_324_45261ca8: '更换验证手机',
    auto_332_a808c5c0: '导出报表',
    auto_335_f142092c: '输出',
    auto_336_6ffb1d8c: '微信支付',
    auto_336_898d3792: '下载导入模板',
    auto_340_0c616071: '上传公众号图片',
    auto_342_c9f03726: '督学结束时间的次日客',
    auto_343_12743d28: '您当前登录的松鼠Ai账号由于长时间未登录存在安全风险，已进入冻结状态，如需继续使用您可进行账号唤醒操作。',
    wakeDialogDeferLogin: '暂不登录',
    wakeDialogWakeNow: '立即唤醒',
    wakeDialogDeferHandle: '暂不处理',
    wakeDialogConfirmed: '已确认',
    wakeDialogSecondMessage: '您ID{campusId}下的松鼠Ai账号正在被唤醒，请前往1{phone}注册的钉钉同意团队邀请确认加入总部。',
    auto_343_1d32944f: '确定',
    auto_344_1fc6be2a: '该账号已经长期未使用为了该账号的安全请保存如下二维码发送给家长',
    auto_344_b8289acd: '请选择督学到期时间',
    auto_345_b57279bb: '请选择督学门店',
    auto_345_e6900270: '确认发布',
    auto_346_8759d587: '姓名',
    auto_347_221bceee: '阶段年级',
    auto_348_7338083d: '学习中心账号',
    auto_349_d9ef97f6: '服务人员',
    auto_350_a8adb4c9: '个月',
    auto_354_fd84dda6: '学前',
    auto_355_b4384eb6: '小学',
    auto_356_170c6c31: '初中',
    auto_357_9e7d394b: '高中',
    auto_358_de3dbeff: '小班',
    auto_359_e011300b: '中班',
    auto_360_cd722ca1: '大班',
    auto_361_694fc5e7: '一年级',
    auto_362_4df5bd40: '二年级',
    auto_363_7373adfb: '三年级',
    auto_364_59a9aa58: '四年级',
    auto_365_01ad86b3: '五年级',
    auto_366_8ce6b148: '六年级',
    auto_368_0431dfa1: '七年级',
    auto_369_d05aef19: '八年级',
    auto_370_dc32dacc: '九年级',
    auto_371_391d9d87: '高一',
    auto_372_b7098df1: '高二',
    auto_373_1888db71: '高三',
    auto_374_259e9142: '高四',
    auto_375_1177b2b7: '保存失败',
    auto_384_0c33fbe1: '客户当前访问账号组织',
    auto_385_64f70ee4: '客户访问账号组织性质',
    auto_386_bc3579ad: '客户访问账号级别',
    auto_387_5f606fef: '客户访问账号全部组织',
    auto_389_c72ec969: '已完结',
    auto_398_5ad9a814: '确认移除体验学员',
    auto_403_94fa966b: '当前督学师',
    auto_404_83e062bf: '当前状态',
    auto_452_bddb8735: '请输入有效数字',
    auto_559_0e34e723: '删除图片',
    auto_560_ba0ce9b2: '替换图片',
    auto_569_4ddb639b: '天内将会有工作人员联',
    auto_570_6c22cb12: '请选择活动开始结束时',
    auto_571_717a46b6: '活动说明图片',
    auto_572_45c0748d: '活动规则图片',
    auto_573_b11b7ea1: '机构介绍图片',
    auto_575_08a98c36: '二维码图片',
    auto_576_be030eaf: '取消',
    auto_623_77451e5c: '已成交',
    auto_629_0678b836: '发起呼叫',
    auto_630_10a00a86: '接通坐席',
    auto_631_c32f7c23: '坐席振铃',
    auto_632_c3c6c0b6: '正在接通中',
    auto_633_3d13bc80: '通话结束',
    auto_634_f6020e93: '坐席空闲',
    auto_635_820490f6: '正在呼叫',
    auto_636_10cc60c3: '正在播放工号',
    auto_637_4718bdad: '坐席接听',
    auto_638_f7a633c5: '通话中',
    auto_639_4e4da016: '此项必填',
    auto_640_2494517e: '全选',
    auto_641_5b463606: '文本',
    auto_649_5399102b: '禁用',
    auto_658_966426c5: '验证失败',
    auto_676_c665a636: '含第一季度业绩',
    auto_677_2371f4ab: '含第一二季度业绩',
    auto_678_3edc269e: '含第一二三季度业绩',
    auto_682_2a8ac5dc: '上传图片失败请删除后',
    auto_683_79283b19: '仅支持或格式的文件',
    auto_684_28a14bbf: '请上传图片',
    auto_685_93ba3225: '请重新上传',
    auto_686_67ae8165: '继续学习',
    auto_688_d90ce707: '请求失败',
    auto_690_faf9e4bc: '底部导航',
    auto_691_87642a19: '您的账号已禁用请联系',
    auto_693_bd7f79f4: '唤醒成功',
    auto_694_777ce4cd: '唤醒失败请稍后重试',
    auto_697_23f1290c: '图片加载失败',
    auto_698_780dddcd: '云仓商品库存统计',
    auto_699_a53fe93d: '云仓仓库库存统计',
    auto_704_ff0bd18a: '自定义课程产品',
    auto_705_0210c642: '商品名称',
    auto_706_b21df977: '充值业绩',
    auto_711_23695f4b: '采购中心',
    auto_712_ea6f60e7: '限制原因',
    auto_1733_2683badf: '为避免耽误您的外呼业务开展根据您选择的开通月数到期后默认',
    auto_13_c84c9c0a: '对应的代理商账户和调整对应期货订单额度',
    auto_22_19c4a75b: '可随时关闭',
    auto_27_d1819be1: '支持退费',
    auto_74_4a659629: '提交申请',
    auto_100_675c965a: '或同等比例',
    auto_101_34344d00: '申请提交成功',
    auto_105_591eb1d9: '辅助线',
    auto_107_cd7d6781: '左右留边',
    auto_112_62e20aa3: '隐藏',
    auto_116_b284796a: '滚动至顶部固定',
    auto_120_46ee5cef: '圆形',
    auto_122_151d2f40: '其他设置',
    auto_124_87dc5816: '居中',
    auto_136_2294e589: '添加',
    auto_140_0eebdadc: '文字导航',
    auto_142_94863036: '滑动',
    auto_162_c3fd44e9: '热卖',
    auto_254_7d9cf14b: '添加好友或粉丝群进行长期维护的场景',
    auto_254_7de05314: '未选中时',
    auto_274_f55c1464: '家长态度如何是否预约下次跟进等',
    auto_294_7ef954c4: '账户余额',
    auto_319_e0bf7ef9: '支付失败',
    auto_390_9c90503b: '处理中',
    auto_399_0204a557: '确认移除学员',
    auto_642_6743fcff: '下拉框',
    auto_643_3d809b1a: '单选',
    auto_644_48a91d08: '多选',
    auto_687_479f10d7: '开始学习',
    auto_703_44431f13: '税额',
    auto_707_8c582976: '赊货订单未完款业绩',
    auto_708_3447fc64: '小计',
    auto_2_7eac2f18: '上海',
    auto_3_d02b13ac: '普陀区',
    auto_64_794b0be6: '工单是您咨询客服时因为问题难度等原因无法为您解答',
    auto_82_f114b59f: '跨主体督学申请详情',
    auto_92_1364e0d6: '审核通过',
    auto_96_0d7118c4: '本月已使用额度未超限',
    auto_97_daafa233: '您的跨主体设备学员已',
    auto_136_ae72634b: '样式一',
    auto_137_72ab3cd3: '样式二',
    auto_164_f34f97e7: '左下',
    auto_165_57d50e6d: '右上',
    auto_188_6a461e5c: '使用支付宝扫一扫',
    auto_199_08498f60: '立体模式',
    auto_242_bcb964f8: '上级代理商',
    auto_278_3c291386: '仅有当前督学师的学生移除后状态会变更为不督学',
    auto_578_fe32b009: '继续发布',
    auto_624_a921024f: '已加微',
    auto_625_6dbd04d4: '已诺访',
    auto_626_c3cdab96: '已到访',
    auto_627_2c036380: '已失效',
    auto_1724_16ad7868: '为避免眈误您的外呼业务开展根据您选择的开通月数到期后默认',
    auto_23_c7c89db7: '内完成商务对接及服务开通部分地区由于号码资源有限开通时间相对',
    auto_111_81f9bfcc: '支持jpgpnggif格式RGB模式不超过5M',
    auto_150_4c7871e5: '收货后支付给配送员实际金额可能会有20的浮动以实际为准',
    auto_153_c2ab8b22: '2预收到付运费自愿选择如果放弃预付运费所享受的折扣须在签收时',
    auto_154_426cde05: '3预收到付运费收取后如果此订单与其他订单合并配送满足免运费条',
    auto_264_96fec72b: '最多添加5个',
    auto_266_ec12174c: '注意：被设置为“紧急联系人”的账号将在极少数（一般一个月不超过3次）的情况下接收总部电话+信息形式的通知，请提醒被设置人员注意接收电话。',
    auto_577_09100b8f: '敏感词检测',
    auto_651_fce225af: '正常',
  },
  serviceCenter: {
    coinMall: '金币商城',
    pickupStore: '自提商店',
    providePickupExchange: '提供自提商店商品兑换功能',
    pickupExchangeDesc: '启用自提商店商品兑换功能后，你的学员可以在自提商店进行下单',
    pickupStoreDisplaySetting: '自提商店展示设置',
    productName: '商品名称',
    enterProductName: '请输入商品名称',
    displaySwitchDesc: '展示开关（开启后会展示在自提商店）',
    productImage: '商品图片',
    exchangePrice: '兑换价格',
    operation: '操作',
    enableSuccess: '开启成功',
    disableSuccess: '关闭成功'
  },
  asEditor: {
    backActivityList: "返回活动列表",
    stepTitleBasicInfo: "活动基础信息",
    stepTitleMarketingMaterial: "营销素材上传",
    stepTitleReview: "页面效果复核",
    auto_1_59cf5f64: "查看操作教程",
    auto_1_8c920303: "页面标题",
    auto_2_5371635d: "重置",
    auto_5_02873c22: "松鼠限时活动",
    auto_6_bb452d56: "查看",
    auto_7_afc01000: "使用通用模板",
    auto_8_7905777d: "编辑完成预览效果",
    auto_8_7ec6ee4e: "重置后您添加或者修改",
    auto_9_cf70301c: "预览",
    auto_10_3a85785f: "查看JSON",
    auto_10_9ae5ae83: "确定",
    auto_11_a9ede7c9: "取消",
    auto_11_c18162c3: "导入JSON",
    auto_12_1db9bee1: "导出JSON",
    auto_12_7f63d57a: "图片广告",
    auto_13_03ee8a72: "保存",
    auto_14_33ef2ff7: "返回列表后，您添加或修改的内容将丢失",
    auto_14_febf0bcd: "iPhone8手机高度",
    auto_15_6200fa9c: "页面设置",
    auto_15_a2fa015c: "提示",
    auto_16_3a051693: "组件管理",
    auto_17_0b3be60c: "组件设置",
    auto_18_50ea7734: "文本内容不能为空，请填写",
    auto_18_e1e54ae8: "填写建议不同的活动名称可用于精细化活动运营若您有多个门店或您",
    auto_19_75e96370: "开始日期",
    auto_19_dc443ba0: "不限时间",
    auto_20_d3ef25f3: "结束日期",
    auto_20_d74687a5: "指定时间",
    auto_21_37deb38e: "活动标题",
    auto_21_b741d0eb: "活动在微信中分享的卡片样式",
    auto_22_17d82179: "下一步",
    auto_22_9ec9bd6b: "活动描述",
    auto_23_46ad2b24: "活动名称",
    auto_23_90f5e9d6: "填写活动基础信息",
    auto_24_ddb80bb3: "上传活动营销素材",
    auto_24_f07cb5f2: "请输入活动名称",
    auto_25_5e199f9c: "活动时间",
    auto_25_fc33d4e0: "检查活动页面效果复核",
    auto_27_f0e1a8e1: "请输入活动标题",
    auto_29_658293df: "请输入活动描述",
    auto_30_3f85201e: "上一步",
    auto_31_5ba29762: "确认发布"
  },
  channelAgents: {
    auto_1_50f0c2f6: "线索状态",
    auto_1_bcc4eca0: "升级申请",
    auto_2_57e34a20: "首笔合同款奖励比例",
    auto_3_1cd11945: "转介绍经销商续费奖励比例",
    auto_3_b8640dd0: "审核时间",
    auto_4_a361b8d8: "介绍人",
    auto_5_8edf6c66: "介绍代理商名称",
    auto_5_e3ef133a: "升级到",
    auto_6_c5d37c9b: "介绍人所在区域",
    auto_6_d48837f6: "请选择",
    auto_7_6370bfd0: "介绍人",
    auto_7_b3e1df51: "升级所需额度",
    auto_8_58f6b177: "当前级别",
    auto_8_c4154868: "介绍人电话",
    auto_9_31823765: "当前可用额度",
    auto_9_ff87ff59: "与客户沟通截图",
    auto_10_aec53ef9: "备注",
    auto_10_af593915: "奖励方式",
    auto_11_5f0a4c24: "当前渠道代级别",
    auto_11_d4e95212: "提现代理商",
    auto_12_216edddb: "状态",
    auto_12_26977aef: "提现代理商名称",
    auto_13_5a9f7023: "提交人代理商",
    auto_13_9842aea2: "a级",
    auto_14_d4a62bd1: "提交代理商名称",
    auto_14_f7a21f63: "b级",
    auto_15_c80f893e: "提交人所在区域",
    auto_16_9c37a83e: "客户姓名",
    auto_17_6fd3cb0e: "客户电话",
    auto_18_9bafa9cb: "客户所在区域",
    auto_19_71922b9a: "客户背景信息",
    auto_20_3d186f73: "跟进的拓展姓名",
    auto_21_94808661: "与拓展沟通截图",
    auto_23_36a06e97: "关联渠道代",
    auto_24_cedc8cdd: "关联渠道代名称",
    auto_26_7ecf0773: "周期",
    auto_28_db1ffdb8: "股东名称",
    auto_29_a20083fa: "投资金额万元",
    auto_30_a849f541: "转介绍奖励",
    auto_31_c83c19fa: "松鼠",
    auto_32_7cfa5436: "松果",
    auto_33_f962ea2f: "补返",
    auto_34_5aacbc1f: "首次",
    auto_35_55d06364: "奖励类型",
    auto_36_5aacf3db: "点击确定后提交申请",
    channelAgentId: "渠道代ID",
    cumulativeChannelAgentLevel: "累计渠道代级别",
    effectiveCycle: "有效期",
    applyTime: "申请时间",
    applicant: "申请人",
    auditOpinion: "审核意见",
    creator: "创建人",
    createTime: "创建时间",
    equityInfo: "股权信息",
    agent: "代理商",
    shareholderName: "股东名称",
    investAmountWanYuan: "投资金额万元",
    relatedChannelAgent: "关联渠道代",
    relatedChannelAgentName: "关联渠道代名称",
    changeLog: "变更记录",
    pleaseSelectStatus: "请选择状态",
    applyStatusPendingReview: "待审核",
    applyStatusToBeSigned: "待签约",
    applyStatusInEffect: "生效中",
    applyStatusExpired: "已过期",
    applyStatusReturned: "审核未通过",
    applyStatusCancelled: "已取消",
    firstContractRewardRatio18: "首笔合同款奖励比例",
    levelA13: "A级",
    levelB14: "B级",
    levelC15: "C级",
    levelD16: "D级",
    perfCustomerAccountOpenTime: "客户账户开通时间",
    perfAccountOpenTime: "账户开通时间",
    perfSource: "业绩来源",
    perfPleaseSelectRewardType: "请选择奖励方式",
    perfPleaseSelectSource: "请选择业绩来源",
    perfContractLastPayTime: "合同款末次支付时间",
    perfContractSignAmount: "签约金额",
    perfContractPaidAmountCol: "已付合同款金额",
    perfUsedQuota: "已使用额度",
    perfAvailableQuota: "可用额度",
    perfIntroducerId: "介绍人id",
    perfIntroducerName: "介绍人名称",
    perfWithdrawableAmount: "可提现金额",
    perfPayoutAgentId: "提现代理商ID",
    perfEffectiveAvailableTotal: "有效的可用额度合计：{amount}元",
    quotaUseType: "使用类型",
    quotaUseLevel: "升级到",
    quotaUseAmount: "使用额度",
    quotaUseUser: "使用人",
    quotaUseTime: "使用时间",
    quotaUseIntroducerId: "介绍人ID",
    quotaUseIntroducerName: "介绍人代理名称",
    quotaUseDealerUpgrade: "经销商升级",
    quotaUseAgentDiscount: "代理商优惠",
    quotaUsePleaseSelectType: "请选择类型",
    regionCurrentChannelAgentLevel: "介绍人当前渠道代级别",
    regionPleaseSelectReferralCustomerId: "请选择转介绍客户ID",
    regionPleaseSelectLevel: "请选择级别",
    regionOrderAmount: "已下单金额",
    afpReferralCustomerId: "转介绍客户ID",
    afpReferralCustomerName: "转介绍客户名称",
    afpReferralContractAmount: "转介绍签约金额",
    afpPurchaseOrderNo: "采购单号",
    afpPaymentStatus: "支付状态",
    afpOrderStatus: "订单状态",
    afpProductName: "产品名称",
    afpPurchaseQuantity: "采购数量",
    afpDeliveryQuantity: "发货数量",
    afpPurchaseUnitPrice: "采购单价",
    afpPurchaseTotalAmount: "采购总金额",
    afpContractPaidAmount: "合同款支付金额",
    afpCumulativeReturnedAmount: "累计已返金额",
    afpDeliveryTime: "发货时间",
    afpRewardRate: "奖励比例",
    afpRewardAmount: "奖励金额",
    afpIsFirstTime: "是否首次",
    afpSettlementYearMonth: "结算年月",
    afpIntroducerOrChannelAgentId: "介绍人/渠道代ID",
    afpChannelAgentName: "渠道代名称",
    afpRegionalAgentId: "区代ID",
    afpRegionalAgentShareAmount: "区代分担金额",
    crfRenewOrderPaymentAmount: "续费货款支付金额",
    crfSubscriptionFeeAmount: "订阅费金额",
    crfRewardCoefficient: "奖励系数",
    crfRewardGranted: "是否已发奖励",
    crfSubscriptionFeeRebate: "订阅费返佣",
    crfValueAddedServiceFee: "增值服务费",
    crfCumulativeChannelLevel: "累计渠道级别",
  },
  inAndOut: {
    auto_1_139fd654: "警告仍有数据错误",
    auto_1_b9dc19e5: "关联订单",
    auto_2_2fd6123c: "部分数据错误若确认导",
    auto_10_91f7dd37: "云仓出库单号",
    auto_11_cd5e206e: "收货地址",
    auto_12_7776b108: "备注",
    auto_14_b13e13c2: "提货单号",
    auto_15_304026c0: "代理商名称",
    auto_16_d949d795: "创建人",
    auto_17_9577c244: "所属仓库",
    auto_18_5459cfcc: "收货人",
    auto_19_f69fde8a: "收货人电话",
    auto_20_6f03a2c9: "省市区",
    auto_21_df0b5b51: "发货状态",
    auto_25_92958a8d: "调库单号",
    auto_28_9f7eb351: "发货仓库",
    auto_30_10d00f1b: "京东调整单号",
    auto_31_3077cfda: "收货仓库",
    auto_33_be3c245c: "调拨单号",
    auto_34_6e471e75: "单据状态",
    auto_35_fe4361fd: "提交时间",
    auto_36_4c3cba93: "云仓库调拨单号",
    auto_39_a8a196d5: "关联调拨单号",
    auto_41_f052cebf: "下载导入模板",
    auto_42_1c0777fe: "导入详情",
  },
  referral: {
    auto_1_17a24c7c: "是否确认要删除该图片",
    auto_1_35aee83a: "微信扫一扫预览",
    auto_2_05b0a2c5: "图片删除",
    auto_2_7cc4dc6c: "预览",
    auto_3_9d5473a6: "模板主题图片",
    auto_4_6bc3b01d: "模板背景图片",
    auto_5_037ad60c: "是否确认要发布该图片",
    auto_6_00c325b5: "图片发布",
    auto_9_be2c267b: "是否确认要下架该图片",
    auto_10_6945e73a: "图片下架",
    auto_11_79b14662: "确定",
    auto_12_b6180373: "取消",
    auto_13_5eb2aadb: "预览图片",
    auto_14_7160357c: "删除图片",
    auto_17_14df2a60: "请选择",
  },
  noviceTasks: {
    auto_1_334e5e27: "请使用松鼠Ai账号绑定的钉钉扫码报名",
    auto_1_38604ac9: "未解锁",
    auto_2_541d9670: "确定",
    auto_2_cc866735: "前往采购",
    auto_3_1f99f135: "请阅读至页面底部并至少阅读10秒钟",
    auto_3_50099175: "立即配置",
    auto_4_820c4504: "请使用微信扫描二维码添加总部专属微信",
    auto_4_861380f9: "我知道了",
    auto_5_76791bc2: "云课堂学习资格已领取",
    auto_5_8ae23169: "帮助中心",
    auto_6_6d258c8a: "报名",
    auto_6_c9482bb1: "提示",
    auto_7_4f1f7097: "添加松鼠AI总部企业微信"
  },
  pineconeBusiness: {
    auto_1_144af95b: "取消",
    auto_2_3f59f53b: "提交",
    auto_3_43d3c963: "开通体验账号",
    auto_4_8f9f1606: "经销商",
    auto_5_c037cf10: "备考省",
    auto_6_c8b7bdd1: "学员手机号",
    auto_7_d69a6971: "请输入学员手机号",
    auto_8_4240a3a7: "学员姓名",
    auto_9_56564323: "请输入学员姓名",
    auto_10_a0d4449d: "阶段年级",
    auto_11_593fdd20: "请选择阶段年级",
    auto_12_0d9ebca8: "体验日期",
    auto_13_92aec48d: "请选择体验日期"
  },
  systemManage: {
    auto_1_ea5a1f41: "分机号/坐席号",
    auto_2_6eaed7f7: "请输入分机号",
    auto_3_f5a4a6b9: "请输入坐席号",
    auto_4_889e956a: "外呼显示手机号",
    auto_5_74b44b16: "请输入外呼显示手机号"
  },
  loadingRedirect: '加载中…',
}
